import cookie from "js-cookie";

const get_user_store = function(api) {
  const state = {
    project_user: {},
    is_show_project_register: false,
  };
  const getters = {
    isUserNotAuthed(state) {
      return !state.project_user.email;
    },
    isUserInProject(state) {
      return state.project_user.state === "auth";
    },
    isUserAuthedNotRegistered(state) {
      return state.project_user.email && state.project_user.state === "guest";
    },
    getProjectUserEmail(state) {
      return state.project_user.email;
    },
    isShowProjectRegister(state) {
      return state.is_show_project_register;
    },
  };
  const mutations = {
    writeProjectUser(state, user) {
      state.project_user = user;
    },
    writeIsShowProjectRegister(state, value) {
      state.is_show_project_register = value;
    },
  };
  const actions = {
    getProjectUser({ commit }) {
      if (cookie.get("game_console")) {
        return true;
      }
      return api()
        .projectUserInfo()
        .then(response => {
          commit("writeProjectUser", response.success.data.data);
          return true;
        });
    },
  };
  return { state, getters, actions, mutations };
};
export default get_user_store;
